export const showsList = [
    // {
    //     date: "3/3/22",
    //     venue: "Gallery Cabaret",
    //     time: "TBD",
    //     cover: "$5 suggested donation",
    //     link: "https://www.gallerycabaret.com/",
    //     eventLink: "",
    //     address: "2020 N Oakley Ave, Chicago, IL 60647"
    // },
    // {
    //     date: "4/10/22",
    //     venue: "The Chop Shop",
    //     time: "Doors @ 5PM",
    //     cover: "$15",
    //     ticketLink : "https://link.dice.fm/g3f8d2e0400c",
    //     venueLink: "https://chopshopchi.com/",
    //     eventLink: "https://www.facebook.com/events/330479492353926",
    //     address: "2033 W. North Ave. Chicago, IL 60647"
    // },
    // {
    //     date: "4/22/22",
    //     venue: "Gallery Cabaret",
    //     time: "TBD",
    //     cover: "$5 suggested donation",
    //     venueLink: "https://www.gallerycabaret.com/",
    //     address: "2020 N Oakley Ave, Chicago, IL 60647"
    // },
    // {
    //     date: "4/24/22",
    //     venue: "The WC Social Club",
    //     time: "Doors @ 5:30PM, Starts @ 6PM",
    //     cover: "$12",
    //     // ticketLink : "https://link.dice.fm/g3f8d2e0400c",
    //     venueLink: "https://www.thewcsocialclub.com/",
    //     // eventLink: "https://www.facebook.com/events/330479492353926",
    //     address: "920 Roosevelt Rd, West Chicago, IL 60185"
    // },
    // {
    //     date: "6/11/22",
    //     venue: "On the Rox",
    //     time: "TBD",
    //     cover: "TBD",
    //     // ticketLink : "https://link.dice.fm/g3f8d2e0400c",
    //     venueLink: "https://www.restaurantji.com/il/kankakee/on-the-rox-/",
    //     // eventLink: "https://www.facebook.com/events/330479492353926",
    //     address: "670 W Station St, Kankakee, IL 60901"
    // },
    // {
    //     date: "7/8/22",
    //     venue: "The WC Social Club",
    //     time: "Doors @ 6:00PM",
    //     cover: "$12 advanced tickets, $15 @ door",
    //     ticketLink : "https://skeletix.com/1614-sounds-like-summer-at-west-chicago-social-c/",
    //     venueLink: "https://www.thewcsocialclub.com/",
    //     eventLink: "https://www.facebook.com/events/543053777450572",
    //     address: "2033 W. North Ave. Chicago, IL 60647"
    // },
    // {
    //     date: "4/22/22",
    //     venue: "Gallery Cabaret",
    //     time: "TBD",
    //     cover: "$5 suggested donation",
    //     venueLink: "https://www.gallerycabaret.com/",
    //     address: "2020 N Oakley Ave, Chicago, IL 60647"
    // },
    {
        date: "8/26/22",
        venue: "The WC Social Club",
        time: "Doors @ 6:00PM",
        cover: "$15-- Purchase tickets directly through us",
        // ticketLink : "Please purchase tickets directly through us",
        venueLink: "https://www.thewcsocialclub.com/",
        eventLink: "https://www.facebook.com/events/4867979266660871?ref=110",
        address: "2033 W. North Ave. Chicago, IL 60647"
    },
]